// The reporter's local identity, stored per-browser. `role` controls whether
// submissions are tagged as internal QA. `teamCode` is the secret the tester
// entered; it's sent with each submission so the SERVER can re-validate and set
// the feedback's `source` — the role here is only a UI hint and is never
// trusted on its own.

export type WidgetRole = "client" | "internal";

export type WidgetProfile = {
  name: string;
  role: WidgetRole;
  teamCode: string;
};

const STORAGE_KEY = "maua-feedback-profile";
const EMPTY: WidgetProfile = { name: "", role: "client", teamCode: "" };

export function readProfile(): WidgetProfile {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { ...EMPTY };
    const p = JSON.parse(raw) as Partial<WidgetProfile>;
    return {
      name: typeof p.name === "string" ? p.name : "",
      role: p.role === "internal" ? "internal" : "client",
      teamCode: typeof p.teamCode === "string" ? p.teamCode : "",
    };
  } catch {
    return { ...EMPTY };
  }
}

export function writeProfile(p: WidgetProfile): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(p));
  } catch {
    /* localStorage unavailable (private mode / blocked) — ignore */
  }
}

/** The teamCode to send with a submission, only when acting as internal. */
export function activeTeamCode(p: WidgetProfile): string | undefined {
  return p.role === "internal" && p.teamCode ? p.teamCode : undefined;
}
